import { memo } from "react";
import { useTheme } from "@mui/material/styles";
import { ADMISSION_CODES, type AdmissionCode } from "@shared/types/rejections.ts";
import { ShieldBadge } from "../../../primitives/data-display/ShieldBadge";

export interface AdmissionFindingBadgeProps {
  code: AdmissionCode;
}

const ESCALATION_CODES: readonly AdmissionCode[] = [
  ADMISSION_CODES.EVIDENCE.UNCLEAR,
  ADMISSION_CODES.COMPATIBILITY.UNCLEAR,
];

/** Two-segment badge for an admission gate code: its namespace on the left, its attribute on the
 *  right ("evidence" | "not primary"). An escalation (the gate could not decide) is tinted as a
 *  warning; every other code is a rejection. */
export const AdmissionFindingBadge = memo(function AdmissionFindingBadge({
  code,
}: AdmissionFindingBadgeProps) {
  const theme = useTheme();
  const [namespace, attribute = ""] = code.split(".");
  const labelColor = ESCALATION_CODES.includes(code)
    ? theme.palette.warning.dark
    : theme.palette.error.dark;
  return (
    <ShieldBadge label={namespace} value={attribute.replace(/_/g, " ")} labelColor={labelColor} />
  );
});
